import { addDummySignals } from './addDummySignals';
import { signalsToXY } from './signalsToXY';
/**
 * Create the xy object from an array of 1D signals.
 * @param signals Array of signals with assigned or unassigned couplings.
 */
export function hackSignalsToXY(signals, options = {}) {
    const newSignals = addDummySignals(signals);
    return signalsToXY(newSignals, options);
}
//# sourceMappingURL=hackSignalsToXY.js.map